import { Select } from 'antd';
import React from 'react';

const SelectComponent = (props) => {
  const { children, className = '', noPopupContainer = false, ...rest } = props;

  return (
    <Select
      showAction={['focus']}
      className={`select-width ${className}`}
      placeholder="Select or Search"
      optionFilterProp="children"
      getPopupContainer={
        noPopupContainer ? undefined : (trigger) => trigger?.parentNode
      }
      showSearch
      allowClear
      maxTagCount="responsive"
      {...rest}
    >
      {children}
    </Select>
  );
};

export default SelectComponent;

SelectComponent.Option = Select?.Option;
SelectComponent.OptGroup = Select?.OptGroup;
